/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SeveraIntegrationSettingsReport = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The SeveraIntegrationSettingsReport model module.
   * @module model/SeveraIntegrationSettingsReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SeveraIntegrationSettingsReport</code>.
   * @alias module:model/SeveraIntegrationSettingsReport
   * @class
   */
  var exports = function() {
    var _this = this;
















































  };

  /**
   * Constructs a <code>SeveraIntegrationSettingsReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SeveraIntegrationSettingsReport} obj Optional instance to populate.
   * @return {module:model/SeveraIntegrationSettingsReport} The populated <code>SeveraIntegrationSettingsReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('BusinessUnitEnabled')) {
        obj['BusinessUnitEnabled'] = ApiClient.convertToType(data['BusinessUnitEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('PersonEnabled')) {
        obj['PersonEnabled'] = ApiClient.convertToType(data['PersonEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('CustomerEnabled')) {
        obj['CustomerEnabled'] = ApiClient.convertToType(data['CustomerEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('ProjectEnabled')) {
        obj['ProjectEnabled'] = ApiClient.convertToType(data['ProjectEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('ProductivityTotalHoursEnabled')) {
        obj['ProductivityTotalHoursEnabled'] = ApiClient.convertToType(data['ProductivityTotalHoursEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('ProductivityProductiveTimeEnabled')) {
        obj['ProductivityProductiveTimeEnabled'] = ApiClient.convertToType(data['ProductivityProductiveTimeEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('BillingUtilizationEnabled')) {
        obj['BillingUtilizationEnabled'] = ApiClient.convertToType(data['BillingUtilizationEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('SalesEnabled')) {
        obj['SalesEnabled'] = ApiClient.convertToType(data['SalesEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('SalesMarginEnabled')) {
        obj['SalesMarginEnabled'] = ApiClient.convertToType(data['SalesMarginEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('SalesMarginPerHourEnabled')) {
        obj['SalesMarginPerHourEnabled'] = ApiClient.convertToType(data['SalesMarginPerHourEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('SalesForecastBillingEnabled')) {
        obj['SalesForecastBillingEnabled'] = ApiClient.convertToType(data['SalesForecastBillingEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('SalesForecastCostsEnabled')) {
        obj['SalesForecastCostsEnabled'] = ApiClient.convertToType(data['SalesForecastCostsEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('SalesForecastAccrualInvoicesEnabled')) {
        obj['SalesForecastAccrualInvoicesEnabled'] = ApiClient.convertToType(data['SalesForecastAccrualInvoicesEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('SalesForecastAccrualPurchasesEnabled')) {
        obj['SalesForecastAccrualPurchasesEnabled'] = ApiClient.convertToType(data['SalesForecastAccrualPurchasesEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('BusinessUnitTrackingLevelID')) {
        obj['BusinessUnitTrackingLevelID'] = ApiClient.convertToType(data['BusinessUnitTrackingLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('PersonTrackingLevelID')) {
        obj['PersonTrackingLevelID'] = ApiClient.convertToType(data['PersonTrackingLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('CustomerTrackingLevelID')) {
        obj['CustomerTrackingLevelID'] = ApiClient.convertToType(data['CustomerTrackingLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('ProjectTrackingLevelID')) {
        obj['ProjectTrackingLevelID'] = ApiClient.convertToType(data['ProjectTrackingLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('ProductivityTotalHoursIndicatorID')) {
        obj['ProductivityTotalHoursIndicatorID'] = ApiClient.convertToType(data['ProductivityTotalHoursIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('ProductivityProductiveTimeIndicatorID')) {
        obj['ProductivityProductiveTimeIndicatorID'] = ApiClient.convertToType(data['ProductivityProductiveTimeIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('BillingUtilizationIndicatorID')) {
        obj['BillingUtilizationIndicatorID'] = ApiClient.convertToType(data['BillingUtilizationIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('SalesIndicatorID')) {
        obj['SalesIndicatorID'] = ApiClient.convertToType(data['SalesIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('SalesMarginIndicatorID')) {
        obj['SalesMarginIndicatorID'] = ApiClient.convertToType(data['SalesMarginIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('SalesMarginPerHourIndicatorID')) {
        obj['SalesMarginPerHourIndicatorID'] = ApiClient.convertToType(data['SalesMarginPerHourIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('SalesForecastBillingIndicatorID')) {
        obj['SalesForecastBillingIndicatorID'] = ApiClient.convertToType(data['SalesForecastBillingIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('SalesForecastCostsIndicatorID')) {
        obj['SalesForecastCostsIndicatorID'] = ApiClient.convertToType(data['SalesForecastCostsIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('SalesForecastAccrualInvoicesIndicatorID')) {
        obj['SalesForecastAccrualInvoicesIndicatorID'] = ApiClient.convertToType(data['SalesForecastAccrualInvoicesIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('SalesForecastAccrualPurchasesIndicatorID')) {
        obj['SalesForecastAccrualPurchasesIndicatorID'] = ApiClient.convertToType(data['SalesForecastAccrualPurchasesIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('UserAPIKey')) {
        obj['UserAPIKey'] = ApiClient.convertToType(data['UserAPIKey'], 'String');
      }
      if (data.hasOwnProperty('IsDefault')) {
        obj['IsDefault'] = ApiClient.convertToType(data['IsDefault'], 'Boolean');
      }
      if (data.hasOwnProperty('ImportBillingAndCostsForecasts')) {
        obj['ImportBillingAndCostsForecasts'] = ApiClient.convertToType(data['ImportBillingAndCostsForecasts'], 'Boolean');
      }
      if (data.hasOwnProperty('CalculateProductivity')) {
        obj['CalculateProductivity'] = ApiClient.convertToType(data['CalculateProductivity'], 'Boolean');
      }
      if (data.hasOwnProperty('CalculateBillingUtilization')) {
        obj['CalculateBillingUtilization'] = ApiClient.convertToType(data['CalculateBillingUtilization'], 'Boolean');
      }
      if (data.hasOwnProperty('CalculateSales')) {
        obj['CalculateSales'] = ApiClient.convertToType(data['CalculateSales'], 'Boolean');
      }
      if (data.hasOwnProperty('CalculateSalesMargin')) {
        obj['CalculateSalesMargin'] = ApiClient.convertToType(data['CalculateSalesMargin'], 'Boolean');
      }
      if (data.hasOwnProperty('CalculateSalesMarginPerHour')) {
        obj['CalculateSalesMarginPerHour'] = ApiClient.convertToType(data['CalculateSalesMarginPerHour'], 'Boolean');
      }
      if (data.hasOwnProperty('CalculateSalesForecast')) {
        obj['CalculateSalesForecast'] = ApiClient.convertToType(data['CalculateSalesForecast'], 'Boolean');
      }
      if (data.hasOwnProperty('SettingsBillingSourceSevera')) {
        obj['SettingsBillingSourceSevera'] = ApiClient.convertToType(data['SettingsBillingSourceSevera'], 'Boolean');
      }
      if (data.hasOwnProperty('SettingsPurchasesSourceSevera')) {
        obj['SettingsPurchasesSourceSevera'] = ApiClient.convertToType(data['SettingsPurchasesSourceSevera'], 'Boolean');
      }
      if (data.hasOwnProperty('SettingsTravelExpensesSourceSevera')) {
        obj['SettingsTravelExpensesSourceSevera'] = ApiClient.convertToType(data['SettingsTravelExpensesSourceSevera'], 'Boolean');
      }
      if (data.hasOwnProperty('SettingsWorkCostSourceSevera')) {
        obj['SettingsWorkCostSourceSevera'] = ApiClient.convertToType(data['SettingsWorkCostSourceSevera'], 'Boolean');
      }
      if (data.hasOwnProperty('RollingSalesIndicatorID')) {
        obj['RollingSalesIndicatorID'] = ApiClient.convertToType(data['RollingSalesIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('RollingSalesMarginIndicatorID')) {
        obj['RollingSalesMarginIndicatorID'] = ApiClient.convertToType(data['RollingSalesMarginIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('RollingSalesMarginPerHourIndicatorID')) {
        obj['RollingSalesMarginPerHourIndicatorID'] = ApiClient.convertToType(data['RollingSalesMarginPerHourIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Boolean} BusinessUnitEnabled
   * @default false
   */
  exports.prototype['BusinessUnitEnabled'] = false;
  /**
   * @member {Boolean} PersonEnabled
   * @default false
   */
  exports.prototype['PersonEnabled'] = false;
  /**
   * @member {Boolean} CustomerEnabled
   * @default false
   */
  exports.prototype['CustomerEnabled'] = false;
  /**
   * @member {Boolean} ProjectEnabled
   * @default false
   */
  exports.prototype['ProjectEnabled'] = false;
  /**
   * @member {Boolean} ProductivityTotalHoursEnabled
   * @default false
   */
  exports.prototype['ProductivityTotalHoursEnabled'] = false;
  /**
   * @member {Boolean} ProductivityProductiveTimeEnabled
   * @default false
   */
  exports.prototype['ProductivityProductiveTimeEnabled'] = false;
  /**
   * @member {Boolean} BillingUtilizationEnabled
   * @default false
   */
  exports.prototype['BillingUtilizationEnabled'] = false;
  /**
   * @member {Boolean} SalesEnabled
   * @default false
   */
  exports.prototype['SalesEnabled'] = false;
  /**
   * @member {Boolean} SalesMarginEnabled
   * @default false
   */
  exports.prototype['SalesMarginEnabled'] = false;
  /**
   * @member {Boolean} SalesMarginPerHourEnabled
   * @default false
   */
  exports.prototype['SalesMarginPerHourEnabled'] = false;
  /**
   * @member {Boolean} SalesForecastBillingEnabled
   * @default false
   */
  exports.prototype['SalesForecastBillingEnabled'] = false;
  /**
   * @member {Boolean} SalesForecastCostsEnabled
   * @default false
   */
  exports.prototype['SalesForecastCostsEnabled'] = false;
  /**
   * @member {Boolean} SalesForecastAccrualInvoicesEnabled
   * @default false
   */
  exports.prototype['SalesForecastAccrualInvoicesEnabled'] = false;
  /**
   * @member {Boolean} SalesForecastAccrualPurchasesEnabled
   * @default false
   */
  exports.prototype['SalesForecastAccrualPurchasesEnabled'] = false;
  /**
   * @member {Integer} BusinessUnitTrackingLevelID
   */
  exports.prototype['BusinessUnitTrackingLevelID'] = undefined;
  /**
   * @member {Integer} PersonTrackingLevelID
   */
  exports.prototype['PersonTrackingLevelID'] = undefined;
  /**
   * @member {Integer} CustomerTrackingLevelID
   */
  exports.prototype['CustomerTrackingLevelID'] = undefined;
  /**
   * @member {Integer} ProjectTrackingLevelID
   */
  exports.prototype['ProjectTrackingLevelID'] = undefined;
  /**
   * @member {Integer} ProductivityTotalHoursIndicatorID
   */
  exports.prototype['ProductivityTotalHoursIndicatorID'] = undefined;
  /**
   * @member {Integer} ProductivityProductiveTimeIndicatorID
   */
  exports.prototype['ProductivityProductiveTimeIndicatorID'] = undefined;
  /**
   * @member {Integer} BillingUtilizationIndicatorID
   */
  exports.prototype['BillingUtilizationIndicatorID'] = undefined;
  /**
   * @member {Integer} SalesIndicatorID
   */
  exports.prototype['SalesIndicatorID'] = undefined;
  /**
   * @member {Integer} SalesMarginIndicatorID
   */
  exports.prototype['SalesMarginIndicatorID'] = undefined;
  /**
   * @member {Integer} SalesMarginPerHourIndicatorID
   */
  exports.prototype['SalesMarginPerHourIndicatorID'] = undefined;
  /**
   * @member {Integer} SalesForecastBillingIndicatorID
   */
  exports.prototype['SalesForecastBillingIndicatorID'] = undefined;
  /**
   * @member {Integer} SalesForecastCostsIndicatorID
   */
  exports.prototype['SalesForecastCostsIndicatorID'] = undefined;
  /**
   * @member {Integer} SalesForecastAccrualInvoicesIndicatorID
   */
  exports.prototype['SalesForecastAccrualInvoicesIndicatorID'] = undefined;
  /**
   * @member {Integer} SalesForecastAccrualPurchasesIndicatorID
   */
  exports.prototype['SalesForecastAccrualPurchasesIndicatorID'] = undefined;
  /**
   * @member {String} UserAPIKey
   * @default ''
   */
  exports.prototype['UserAPIKey'] = '';
  /**
   * @member {Boolean} IsDefault
   * @default false
   */
  exports.prototype['IsDefault'] = false;
  /**
   * @member {Boolean} ImportBillingAndCostsForecasts
   * @default false
   */
  exports.prototype['ImportBillingAndCostsForecasts'] = false;
  /**
   * @member {Boolean} CalculateProductivity
   * @default false
   */
  exports.prototype['CalculateProductivity'] = false;
  /**
   * @member {Boolean} CalculateBillingUtilization
   * @default false
   */
  exports.prototype['CalculateBillingUtilization'] = false;
  /**
   * @member {Boolean} CalculateSales
   * @default false
   */
  exports.prototype['CalculateSales'] = false;
  /**
   * @member {Boolean} CalculateSalesMargin
   * @default false
   */
  exports.prototype['CalculateSalesMargin'] = false;
  /**
   * @member {Boolean} CalculateSalesMarginPerHour
   * @default false
   */
  exports.prototype['CalculateSalesMarginPerHour'] = false;
  /**
   * @member {Boolean} CalculateSalesForecast
   * @default false
   */
  exports.prototype['CalculateSalesForecast'] = false;
  /**
   * @member {Boolean} SettingsBillingSourceSevera
   * @default false
   */
  exports.prototype['SettingsBillingSourceSevera'] = false;
  /**
   * @member {Boolean} SettingsPurchasesSourceSevera
   * @default false
   */
  exports.prototype['SettingsPurchasesSourceSevera'] = false;
  /**
   * @member {Boolean} SettingsTravelExpensesSourceSevera
   * @default false
   */
  exports.prototype['SettingsTravelExpensesSourceSevera'] = false;
  /**
   * @member {Boolean} SettingsWorkCostSourceSevera
   * @default false
   */
  exports.prototype['SettingsWorkCostSourceSevera'] = false;
  /**
   * @member {Integer} RollingSalesIndicatorID
   */
  exports.prototype['RollingSalesIndicatorID'] = undefined;
  /**
   * @member {Integer} RollingSalesMarginIndicatorID
   */
  exports.prototype['RollingSalesMarginIndicatorID'] = undefined;
  /**
   * @member {Integer} RollingSalesMarginPerHourIndicatorID
   */
  exports.prototype['RollingSalesMarginPerHourIndicatorID'] = undefined;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


